<template>
  <toggle-details>
    <div class="see-details" slot-scope="{ opened, toggle, isMounted }">
      <div class="main-content">
        <slot v-bind="{ opened, toggle, isMounted }" />
      </div>
      <div
          class="detailed-content"
          :class="[{ opened }]"
      >
        <transition name="expand-y">
          <slot v-if="opened" name="details" />
        </transition>
        <div class="activator">
          <button
              v-on:click="toggle"
              v-on:enter="toggle"
              v-on:space.prevent="toggle"
              aria-label="Toggle details"
              v-bind:aria-expanded="opened ? 'true' : 'false'"
          >
            <span>{{tc('booking.details')}}</span>
            <div :class="opened ? 'icon-minus' : 'icon-add'"></div>
          </button>
        </div>
      </div>
    </div>
  </toggle-details>
</template>

<script>
  import { mapGetters } from 'vuex'
  export default {
    name: 'see-details',
    computed: {
      ...mapGetters('i18n', ['tc'])
    }
  }
</script>
